<template>
  <div>
    <Badge class="status-base" :status="calloutStatus">
      <StakeTooltip v-if="status === 'failed'" :label="failureReason">
        {{ message }}
      </StakeTooltip>
      <span v-else>{{ message }}</span>
    </Badge>
  </div>
</template>


<script>
import StakeTooltip from '@stakeui/StakeTooltip.vue';
import { Badge } from '@stakeui';

export default {
  name: 'MeetingStatus',
  components: {
    StakeTooltip,
    Badge,
  },
  props: {
    status: {
      type: String,
      required: true,
    },
    failureReason: {
      type: String,
      default: 'We were unable to process this meeting',
    },
  },
  data() {
    return { /* Local variables */ };
  },
  computed: {
    message() {
      if (this.status === 'completed' || this.status === 'failed') {
        return this.status;
      }
      return 'pending';
    },
    calloutStatus() {
      const statusToCallout = {
        'completed': 'success',
        'processing': 'warning',
        'failed': 'danger',
      }
      if (this.status in statusToCallout) {
        return statusToCallout[this.status];
      }
      return '';
    }
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>
  .status-base {
    text-transform: capitalize;
  }
</style>
